import {JsonObject, JsonProperty} from 'json2typescript';
import {EmptyControl, Required} from '@hvlng/framework-bff/core';
import {CodeTextModel} from '../../code-text/model/code-text-model';

@JsonObject('KovanHrPerIdentificationSubtypeModel')
export class PerIdentificationSubtypeModel extends CodeTextModel {
    @Required()
    @JsonProperty('hrmTypeId', Number, true)
    hrmTypeId: number = null;

    @EmptyControl()
    @JsonProperty('hrmTypeCode', String, true)
    hrmTypeCode: string = null;

    @EmptyControl()
    @JsonProperty('hrmDetailTypeId', Number, true)
    hrmDetailTypeId: number = null;
}
